import role from '@/router/service-with-clients/admin-contractor/role'
import mainVehicle from '@/router/service-with-clients/admin-contractor/main-vehicle'
import appraisal from '@/router/service-with-clients-intbls/admin-contractor/appraisal/index'
import clients from '@/router/service-with-clients/admin-contractor/clients'
import headers from '@/router/share/task-headers'

export default function (service, name) {
  return [
    ...role(service, name),
    ...mainVehicle(service, name),
    ...appraisal(service, name),
    ...clients(service, name),
    ...headers(service, name)
  ]
}
